// extracted by mini-css-extract-plugin
module.exports = {"tags":"tagsseo_tags__iYl4b","rowWrap":"tagsseo_rowWrap__vbyS_"};